class MobileDrawerTabs extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === "true") return;

    this.dataset.initialized = "true";
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.parentElement.querySelectorAll('[role="tabpanel"]'));

    this.addEventListener("click", (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (tab) this.selectTab(tab);
    });

    this.addEventListener("keydown", (event) => this.handleKeydown(event));

    const drawer = this.closest("header-sidebar");
    drawer?.addEventListener("dialog:after-hide", () => this.selectTab(this.tabs[0], false));
  }

  selectTab(selectedTab, moveFocus = true) {
    if (!selectedTab) return;

    this.tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      tab.setAttribute("aria-selected", String(isSelected));
      tab.tabIndex = isSelected ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== selectedTab.getAttribute("aria-controls");
    });

    if (moveFocus) selectedTab.focus({ preventScroll: true });
  }

  handleKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.target);
    if (currentIndex < 0) return;

    let nextIndex;

    if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === "Home") nextIndex = 0;
    if (event.key === "End") nextIndex = this.tabs.length - 1;

    if (nextIndex === undefined) return;

    event.preventDefault();
    this.selectTab(this.tabs[nextIndex]);
  }
}

if (!customElements.get("mobile-drawer-tabs")) {
  customElements.define("mobile-drawer-tabs", MobileDrawerTabs);
}
